import { useState } from "react";

function formatearMonto(v) {
  const n = Number(v);
  if (!isFinite(n)) return "0.00";
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Deja el string en un decimal válido mientras se escribe: un solo signo menos
// al inicio, un solo punto y máximo 2 decimales. Evita que el estado guarde
// valores no parseables (p. ej. "16.320.000" con puntos de miles, "1.555" o
// "-") que el backend rechazaría y harían fallar TODA la guardada.
export function sanitizarMonto(raw) {
  let s = String(raw).replace(/[^\d.-]/g, "");
  const negativo = s[0] === "-";
  s = s.replace(/-/g, "");
  const punto = s.indexOf(".");
  if (punto !== -1) {
    const entero = s.slice(0, punto);
    const decimales = s.slice(punto + 1).replace(/\./g, "").slice(0, 2);
    s = `${entero}.${decimales}`;
  }
  return (negativo ? "-" : "") + s;
}

/**
 * Input de monto con separador de miles (0,000.00). Muestra el valor formateado
 * cuando no tiene foco; al enfocarlo muestra el número crudo para editar sin
 * que el cursor salte por las comas.
 */
export function MoneyInput({ value, onChange, style, className }) {
  const [focused, setFocused] = useState(false);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={focused ? value : formatearMonto(value)}
      onFocus={(e) => { setFocused(true); e.target.select(); }}
      onBlur={() => setFocused(false)}
      onChange={(e) => onChange(sanitizarMonto(e.target.value))}
      style={style}
      className={className}
    />
  );
}
